import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import Container from 'Components/Container';
import Button from '@material-ui/core/Button';
import pages from 'Constants/pages';
import { Link, withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'Store/actions';
import Box from '@material-ui/core/Box';
import usaFlag from 'Images/usa-flag-bw.svg';
import { withTheme } from '@material-ui/core';

const siteLinks = [pages.foundSomething, pages.registerYourTag];

const companyLinks = [pages.contact, pages.privacyPolicy, pages.tos];

const styles = theme => ({
  footer: {
    padding: '48px 48px 142px 48px',
    backgroundColor: theme.palette.secondary.main,
    boxShadow: 'inset 0 39px 50px -20px rgba(0,0,0,0.3)',
  },
  container: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  social: {
    display: 'flex',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '50px',
    },
  },
  socialButton: {
    marginRight: '7px',
    backgroundColor: 'rgba(255,255,255,0.1)',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      marginRight: '25px',
    },
  },
  socialIcon: {
    height: '17px',
  },
  footerLinksContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  footerLinksSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  linksHeader: {
    color: 'white',
    fontFamily: "'Work Sans', sans-serif",
    lineHeight: '32px',
    fontSize: '16px',
    fontWeight: 700,
    marginBottom: '5px',
  },
  textLink: {
    textTransform: 'initial',
    color: 'white',
    fontFamily: "'Work Sans', sans-serif",
    lineHeight: '32px',
    justifyContent: 'flex-start',
    fontSize: '16px',
    fontWeight: 400,
    paddingLeft: 0,
    marginBottom: '5px',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#45A358',
    },
  },
  socialInnerContainer: {
    marginBottom: 15,
  },
  madeInUsa: {
    color: 'white',
    fontFamily: "'Work Sans', sans-serif",
    lineHeight: '32px',
    fontSize: '16px',
    fontWeight: 400,
    marginTop: 5,
    display: 'flex',
    alignItems: 'center',
  },
  usaFlag: {
    opacity: 0.75,
    width: 35,
    marginRight: 10,
  },
  siteLinksSection: {
    marginRight: '100px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: '30px',
    },
  },
});

function Footer({ classes, setActiveModal, className }) {
  const renderLinksSection = (links, sectionTitle, sectionStyles) => {
    const textLinks = links.map(link => {
      let conditionalProps = {};
      if (link.type === 'modal') {
        conditionalProps.onClick = () => {
          setActiveModal(link.name);
        };
      } else {
        conditionalProps.to = {
          pathname: link.pathname,
        };
      }
      return (
        <Button {...conditionalProps} className={classes.textLink} disableRipple key={link.label} component={Link}>
          {link.label}
        </Button>
      );
    });

    return (
      <div className={clsx(classes.footerLinksSection, sectionStyles)}>
        <Typography variant="h6" gutterBottom className={classes.linksHeader}>
          {sectionTitle}
        </Typography>
        {textLinks}
      </div>
    );
  };

  return (
    <footer className={clsx(classes.footer, className)}>
      <Container className={classes.container}>
        <div className={classes.social}>
          <Box display="flex" flexDirection="column">
            <div className={classes.socialInnerContainer}>
              <Fab
                size="small"
                color="primary"
                aria-label="facebook"
                className={classes.socialButton}
                href="https://www.facebook.com/Ownerfy-101495804650792"
                target="_blank"
              >
                <FacebookIcon fontSize="small" className={classes.socialIcon} />
              </Fab>
              <Fab
                size="small"
                color="primary"
                aria-label="twitter"
                className={classes.socialButton}
                href="https://twitter.com/ownerfy"
                target="_blank"
              >
                <TwitterIcon fontSize="small" className={classes.socialIcon} />
              </Fab>
              <Fab
                size="small"
                color="primary"
                aria-label="instagram"
                className={classes.socialButton}
                href="https://www.instagram.com/OwnerfyOfficial/"
                target="_blank"
              >
                <InstagramIcon fontSize="small" className={classes.socialIcon} />
              </Fab>
            </div>
            <a className={classes.textLink} href="mailto:support@ownerfy.com">
              support@ownerfy.com
            </a>
            <a className={classes.textLink} href="tel:1-424-272-5816">
              1-424-272-5816
            </a>
            <p className={classes.madeInUsa}>
              <img className={classes.usaFlag} src={usaFlag} alt="USA flag" />
              <span>Made in the USA</span>
            </p>
          </Box>
        </div>
        <div className={classes.footerLinksContainer}>
          {/* {renderLinksSection(siteLinks, 'Ownerfy', classes.siteLinksSection)} */}
          {renderLinksSection(companyLinks, 'Company')}
        </div>
      </Container>
    </footer>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(connect(null, mapDispatchToProps)(withStyles(styles)(Footer)));
